import { Container } from '@mui/material';
import styled from 'styled-components';

export const StyledContainer = styled(Container)`
  max-width:1450px !important;
  // height:100vh;
`;